module.exports = __webpack_public_path__ + "static/screen-previsioni-dark-7de7b99dfd4fb162d75cd352ae5c6fb7.png";